module.exports = __webpack_public_path__ + "files/43771aa476e152cfc85a289c24548078.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/arvo-bold-webfont.woff2
 ** module id = 887
 ** module chunks = 0
 **/